import React from 'react';
import {
  Flex,
  Text,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  Link,
  Icon,
} from '@chakra-ui/react';
import { FaUser } from 'react-icons/fa';
import { LuPanelLeftClose, LuPanelLeftOpen } from 'react-icons/lu';
import useAuthStore from '../stores/auth.store';

const Navbar = ({ isOpen, onOpen, onClose }) => {
  const logout = useAuthStore(state => state.logout);

  return (
    <Flex
      p={2}
      w={'full'}
      as={Flex}
      align={'center'}
      justify={'space-between'}
      borderBottom={'1px solid'}
      borderColor={'gray.200'}
    >
      <Flex alignItems={'center'} gap={2}>
        <IconButton
          icon={<Icon as={isOpen ? LuPanelLeftClose : LuPanelLeftOpen} />} // ✅ `as` yerine `icon`
          onClick={() => (isOpen ? onClose() : onOpen())}
          textColor={'bisque.400'}
          variant={'unstyled'}
          size={'sm'}
          _hover={{
            cursor: 'pointer',
          }}
        />

        <Text fontSize={'lg'} fontWeight={600}>
          Sensor Snap
        </Text>
      </Flex>
      <Menu>
        <MenuButton as={IconButton} icon={<FaUser />} />
        <MenuList>
          <MenuItem as={Link} href={'/profile'}>
            Profile
          </MenuItem>
          <MenuItem onClick={logout}>Logout</MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  );
};

export default Navbar;
